module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.eot
// module id = 381
// module chunks = 0